import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserPermissionOverride, UserPermissionOverrideSaveRequest } from '../models/UserPermissionOverride';
import { ErrorService } from '../shared/services/error.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionOverrideService {
  private baseUrl = environment.microservices.user;

  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) {}

  getByUserId(userId: number): Observable<UserPermissionOverride[]> {
    return this.http.get<UserPermissionOverride[]>(`${this.baseUrl}/GetUserPermissionOverrides/${userId}`).pipe(
      catchError(err => {
        this.errorService.showErrorMessage('Erro ao buscar permissões do usuário');
        return throwError(() => err);
      })
    );
  }

  save(request: UserPermissionOverrideSaveRequest): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.baseUrl}/SaveUserPermissionOverrides`, request).pipe(
      catchError(err => {
        this.errorService.showErrorMessage('Erro ao salvar permissões do usuário');
        return throwError(() => err);
      })
    );
  }

  delete(overrideId: number, deletedBy: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/DeleteUserPermissionOverride/${overrideId}`, {
      body: { deletedBy }
    }).pipe(
      catchError(err => {
        this.errorService.showErrorMessage('Erro ao remover permissão do usuário');
        return throwError(() => err);
      })
    );
  }
}
